import { get } from 'lodash';
import TrialRecapsApi from 'api/v2/TrialRecapsApi';
import Vue from 'vue';

const fetchTrialRecaps = async (context, features) => {
  const recapResponse = await TrialRecapsApi.fetchTrialRecaps(features);
  const recapData = recapResponse.data;
  context.commit('SET_RECAP_DATA', { recapData });
  return recapData;
};

function getRecapsForFeatures(state) {
  return (features) => {
    let recap;
    const recaps = {};
    const trialRecaps = get(state, 'recaps');
    features.forEach((feature) => {
      recap = get(trialRecaps, feature, []);
      if (recap.length > 0) {
        recaps[feature] = recap;
      }
    });
    return recaps;
  };
}

function SET_RECAP_DATA(state, { recapData }) {
  Vue.set(state, 'recaps', recapData);
}

export const TrialRecapModule = () => ({
  namespaced: true,
  state: {
    recaps: [],
  },
  actions: {
    fetchTrialRecaps,
  },
  getters: {
    getRecapsForFeatures,
  },
  mutations: {
    SET_RECAP_DATA,
  },
});

export default TrialRecapModule();
